import threadsConfigurationResource from 'src/actions/threads/threadsConfigurationResource';
import { useDocumentResourceAll } from 'src/presentation/hooks/useDocumentResource';

const useThreadsConfiguration = () => {
  const { value: config } = useDocumentResourceAll(threadsConfigurationResource);
  return {
    isFeatureEnabled: config?.enabled ?? false,
  };
};

export default useThreadsConfiguration;
